import { useFormContext, Controller } from 'react-hook-form';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseTextInput from './BaseTextInput';

type Props = {
  name: string;
  required?: boolean;
  labelAdornment?: JSX.Element | null;
  helperStyles?: SxProps<Theme>;
  showErrorAlways?: boolean;
} & TextFieldProps;

const ControlledTextInput = ({
  name,
  required,
  labelAdornment,
  sx,
  type,
  showErrorAlways,
  ...props
}: Props) => {
  const { control } = useFormContext();
  const convertToNumber = type === 'number';
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name={name}
      rules={required ? { required: t('errors.required') } : { required: false }}
      render={({ field }) => (
        <BaseTextInput
          onChange={({ target: { value } }) => field.onChange(convertToNumber ? +value : value)}
          field={field}
          name={name}
          required={required}
          labelAdornment={labelAdornment}
          sx={{ ...sx }}
          showErrorAlways={showErrorAlways}
          {...props}
        />
      )}
    />
  );
};

export default ControlledTextInput;
